import { render, staticRenderFns } from "./SupplierManufacturingHome.vue?vue&type=template&id=33221d2a&scoped=true"
import script from "./SupplierManufacturingHome.vue?vue&type=script&lang=js"
export * from "./SupplierManufacturingHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33221d2a",
  null
  
)

export default component.exports